/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item11Inputs */

const ja_playdata_eventreport_example_item11 = /** @type {(inputs: Playdata_Eventreport_Example_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会の統計概要`)
};

const en_playdata_eventreport_example_item11 = /** @type {(inputs: Playdata_Eventreport_Example_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Summary (Overview)`)
};

/**
* | output |
* | --- |
* | "Event Summary (Overview)" |
*
* @param {Playdata_Eventreport_Example_Item11Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item11 = /** @type {((inputs?: Playdata_Eventreport_Example_Item11Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item11Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item11(inputs)
	return en_playdata_eventreport_example_item11(inputs)
});
export { playdata_eventreport_example_item11 as "playdata_eventReport_example_item1" }